import {AuthSessionService} from './shared/auth/auth-session.service';
import {ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners} from '@angular/core';
import {provideRouter, withComponentInputBinding, withInMemoryScrolling, withRouterConfig} from '@angular/router';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideEchartsCore} from 'ngx-echarts';
import {authInterceptor, provideAuth} from 'angular-auth-oidc-client';

import {routes} from './app.routes';

import {http400Interceptor} from './shared/commons/interceptors/http400-interceptor';
import {http401Interceptor} from './shared/commons/interceptors/http401-interceptor';
import {http409Interceptor} from './shared/commons/interceptors/http409-interceptor';
import {http413Interceptor} from './shared/commons/interceptors/http413-interceptor';
import {http422Interceptor} from './shared/commons/interceptors/http422-interceptor';
import {externalApiErrorInterceptor} from './shared/commons/interceptors/external-api-error-interceptor';
import {http5xxInterceptor} from './shared/commons/interceptors/http5xx-interceptor';
import {loadingInterceptor} from './shared/commons/interceptors/loading-interceptor';
import {authConfig} from './auth.config';
import {provideClientHydration} from '@angular/platform-browser';
import {CustomDatepickerI18n, I18n} from './shared/commons/gt-ng-datepicker/custom-datepicker';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbTimeAdapter,
  NgbTimepickerI18n
} from '@ng-bootstrap/ng-bootstrap';
import {CustomNgbDateNativeAdapterToString} from './shared/commons/gt-ng-datepicker/date-native-adaptor';
import {CustomNgbDateParser} from './shared/commons/gt-ng-datepicker/custom-ngb-date-parser';
import {CustomNgbTimeAdapter} from './shared/commons/gt-ng-datepicker/custom-time-native-adaptor';
import {CustomTimepickerI18n} from './shared/commons/gt-ng-datepicker/custom-timepicker';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withRouterConfig({onSameUrlNavigation: "reload"}),
      withInMemoryScrolling({scrollPositionRestoration: 'enabled'}),
      withComponentInputBinding(),
    ),
    provideAuth(authConfig),
    provideAppInitializer(() => inject(AuthSessionService).initialize()),
    provideClientHydration(),
    provideHttpClient(
      // withFetch(),
      withInterceptors([
        authInterceptor(),
        loadingInterceptor,
        http400Interceptor,
        http401Interceptor,
        http409Interceptor,
        http413Interceptor,
        http422Interceptor,
        externalApiErrorInterceptor,
        http5xxInterceptor
      ])
    ),
    provideEchartsCore({ echarts: () => import('echarts') }),
    I18n,
    {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n},
    {provide: NgbDateAdapter, useClass: CustomNgbDateNativeAdapterToString},
    {provide: NgbDateParserFormatter, useClass: CustomNgbDateParser},
    {provide: NgbTimeAdapter, useClass: CustomNgbTimeAdapter},
    {provide: NgbTimepickerI18n, useClass: CustomTimepickerI18n},
  ]
};
